import React, { useEffect, useRef } from "react";
import { Animated, Easing, StyleSheet, View } from "react-native";
import { colors } from "../theme/tokens";

export function MusicEqualizer({ size = 14 }: { size?: number }) {
  const values = [useRef(new Animated.Value(0.4)).current, useRef(new Animated.Value(1)).current, useRef(new Animated.Value(0.6)).current];

  useEffect(() => {
    const animations = values.map((value, index) => Animated.loop(Animated.sequence([
      Animated.delay(index * 120),
      Animated.timing(value, { toValue: index === 1 ? 0.35 : 1, duration: 360, easing: Easing.inOut(Easing.quad), useNativeDriver: true }),
      Animated.timing(value, { toValue: index === 1 ? 1 : 0.3, duration: 420, easing: Easing.inOut(Easing.quad), useNativeDriver: true }),
    ])));
    animations.forEach((animation) => animation.start());
    return () => animations.forEach((animation) => animation.stop());
  }, []);

  return (
    <View accessibilityLabel="Playing" style={[styles.equalizer, { height: size }]}>
      {values.map((value, index) => (
        <Animated.View key={index} style={[styles.bar, { height: size, transform: [{ scaleY: value }] }]} />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  equalizer: { flexDirection: "row", alignItems: "flex-end", gap: 2 },
  bar: { width: 3, borderRadius: 1, backgroundColor: colors.brand },
});
